import { lazy } from 'react';

// Each route exposes its dynamic import so we can prefetch on hover/focus.
const make = (loader) => ({
  Component: lazy(loader),
  prefetch: () => { try { loader(); } catch {} },
});

export const Login        = make(() => import(/* webpackChunkName: "login"        */ '../components/Login'));
export const Signup       = make(() => import(/* webpackChunkName: "signup"       */ '../components/Signup'));
export const VerifyNotice = make(() => import(/* webpackChunkName: "verify-notice"*/ '../components/VerifyNotice'));
export const Verified     = make(() => import(/* webpackChunkName: "verified"     */ '../components/Verified'));
export const ForgotPassword = make(() => import(/* webpackChunkName: "forgot-password" */ '../components/ForgotPassword'));
export const ResetPassword  = make(() => import(/* webpackChunkName: "reset-password"  */ '../components/ResetPassword'));
export const Dashboard    = make(() => import(/* webpackChunkName: "dashboard"    */ '../pages/Dashboard'));
export const Profile      = make(() => import(/* webpackChunkName: "profile"      */ '../pages/Profile'));
export const AdminUsers   = make(() => import(/* webpackChunkName: "admin-users"  */ '../pages/AdminUsers'));
export const Quizzes      = make(() => import(/* webpackChunkName: "quizzes"      */ '../pages/Quizzes'));
export const QuizEditor   = make(() => import(/* webpackChunkName: "quiz-editor"  */ '../pages/QuizEditor'));
export const QuizPreview  = make(() => import(/* webpackChunkName: "quiz-preview" */ '../pages/QuizPreview'));
export const AiGenerate   = make(() => import(/* webpackChunkName: "ai-generate"  */ '../pages/AiGenerate'));
export const PublicQuizTake   = make(() => import(/* webpackChunkName: "share-take"   */ '../pages/PublicQuizTake'));
export const PublicQuizResult = make(() => import(/* webpackChunkName: "share-result" */ '../pages/PublicQuizResult'));
export const TakeQuiz         = make(() => import(/* webpackChunkName: "take-quiz"    */ '../pages/TakeQuiz'));
export const History          = make(() => import(/* webpackChunkName: "history"      */ '../pages/History'));
export const AttemptReview    = make(() => import(/* webpackChunkName: "attempt"      */ '../pages/AttemptReview'));
export const AdminAuditLogs   = make(() => import(/* webpackChunkName: "audit-logs"   */ '../pages/AdminAuditLogs'));
export const AdminAiConfig    = make(() => import(/* webpackChunkName: "ai-config"    */ '../pages/AdminAiConfig'));

// Map route paths -> prefetch fn (used by Sidebar links).
export const prefetchByPath = {
  '/dashboard':     Dashboard.prefetch,
  '/profile':       Profile.prefetch,
  '/admin/users':   AdminUsers.prefetch,
  '/login':         Login.prefetch,
  '/signup':        Signup.prefetch,
  '/verify-notice': VerifyNotice.prefetch,
  '/verified':      Verified.prefetch,
  '/forgot-password': ForgotPassword.prefetch,
  '/reset-password':  ResetPassword.prefetch,
  '/quizzes':       Quizzes.prefetch,
  '/quizzes/new':   QuizEditor.prefetch,
  '/ai/generate':   AiGenerate.prefetch,
  '/history':       History.prefetch,
  '/admin/audit-logs': AdminAuditLogs.prefetch,
  '/admin/ai-config':  AdminAiConfig.prefetch,
};

// Kick off the chunk for whatever URL the user just landed on, so the first
// paint is the actual page (not the Suspense void). Falls back to /login.
export const preloadInitialRoute = () => {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/login';
  const fn = prefetchByPath[path] || Login.prefetch;
  fn();
};
